module.exports = __webpack_public_path__ + "img/boxed-7.63068c51.jpg";